module.exports = __webpack_public_path__ + "img/packageLimCondition.48dad7c5.png";